<script setup lang="ts">
import { watch, onUnmounted } from 'vue'
import { useBodyScrollLock } from '../composables/useBodyScrollLock'

import Icon from './Icon.vue'
import { faXmark } from '@repo/icons/light/faXmark'

const emit = defineEmits(['toggle-drawer'])

const props = defineProps<{ isDrawerOpen: boolean; noControls?: boolean }>()
const { lock, unlock } = useBodyScrollLock()

// function toggleScrolling() {
//   const scrollClass = "u-no-scroll";
//   const el = document.documentElement;

//   if (el.classList.contains(scrollClass)) {
//     el.classList.remove(scrollClass);
//   } else {
//     el.classList.add(scrollClass);
//   }
// }

function handleEscKey(e: KeyboardEvent) {
  if (e.key === 'Escape' && props.isDrawerOpen) {
    toggleDrawer()
  }
}

function handleOverlayClick() {
  if (props.isDrawerOpen) {
    toggleDrawer()
  }
}

watch(
  () => props.isDrawerOpen,
  (isOpen) => {
    if (isOpen) {
      lock() // lock scrolling
      document.addEventListener('keydown', handleEscKey)
    } else {
      unlock() // unlock scrolling
      document.removeEventListener('keydown', handleEscKey)
    }
  }
)

onUnmounted(() => {
  document.removeEventListener('keydown', handleEscKey)
})

function requestToggle() {
  emit('toggle-drawer')
}

// function toggleEscListener() {
//   document.addEventListener("keydown", escListener, {
//     once: true,
//   });
// }
function toggleDrawer() {
  // toggleEscListener();
  // toggleScrolling();
  emit('toggle-drawer')
}
</script>
<template>
  <aside
    v-bind="$attrs"
    class="drawer-menu is-desktop z-20 overscroll-contain py-0 shadow-2xl"
    :class="{ 'is-active': isDrawerOpen }"
  >
    <div class="flex h-full flex-col justify-between">
      <div
        class="navbar-basket has-dropdown has-items-right w-full h-18"
        :class="{ 'hidden lg:flex': noControls }"
        title="Close drawer"
        @click="toggleDrawer()"
      >
        <div class="cursor-pointer hover:bg-slate-100 h-full aspect-square grid place-items-center">
          <Icon
            :icon="faXmark"
            class="text-2xl"
          />
        </div>
      </div>
      <slot></slot>

      <slot name="footer"></slot>
    </div>
  </aside>
  <transition name="fade">
    <div
      v-show="isDrawerOpen"
      class="overlay is-hidden-touch z-10 bg-black/40 backdrop-blur-xs"
      @click="handleOverlayClick"
    />
  </transition>
</template>
